<template>
  <section>
    <v-btn
        v-if="canSkip"
        class="skip"
        color="warning"
        text
        :ripple="false"
        @click="$emit('skip')"
    >
      пропустить
      <v-icon
          class="warning--text"
          right
      >
        mdi-close
      </v-icon>
    </v-btn>
    <div
        class="bg"
        ref="bg"
    >
      <div class="slogan">
        <div
            v-if="$vuetify.breakpoint.mobile"
            class="margin-xs"
        ></div>
        <div
            v-else
            class="margin-lg"
        ></div>
        <h1 class="text-center">Участвуй в Совместных Покупках <br/> легко и просто!</h1>
      </div>

      <v-btn
          v-if="showToFeatures"
          class="to-features"
          color="accent"
          fab
          :ripple="false"
          @click="toFeatures"
      >
        <v-icon>mdi-chevron-down</v-icon>
      </v-btn>
    </div>

    <section
        id="features"
        class="block"
        ref="features"
    >
      <h2 class="heading">Наши возможности:</h2>
      <v-row>
        <v-col
            class="feature text-center"
            cols="12"
            sm="6"
        >
          <v-icon class="feature-icon primary--text">mdi-wallet</v-icon>
          <h6 class="my-10">Отобразим счета по закупкам</h6>
        </v-col>
        <v-col
            class="feature text-center"
            cols="12"
            sm="6"
        >
          <v-icon class="feature-icon primary--text">mdi-email-outline</v-icon>
          <h6 class="my-10">Уведомим об изменениях в закупках</h6>
        </v-col>
        <v-col
            class="feature text-center"
            cols="12"
            sm="6"
        >
          <v-icon class="feature-icon primary--text">mdi-history</v-icon>
          <h6 class="my-10">Сохраним историю заказов</h6>
        </v-col>
        <v-col
            class="feature text-center"
            cols="12"
            sm="6"
        >
          <v-icon class="feature-icon primary--text">mdi-message-reply-text</v-icon>
          <h6 class="my-10">Удобно отобразим ваши комментарии</h6>
        </v-col>
      </v-row>
    </section>

    <section
        id="instruction"
        class="block"
    >
      <h2 class="heading">Как пользоваться?</h2>
      <div class="video-container">
        <iframe src="https://vk.com/video_ext.php?oid=-134681298&id=456239223&autoplay=0" allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;" frameborder="0" allowfullscreen></iframe>
      </div>
    </section>
  </section>
</template>

<script>
import Screen from '@/services/screen'

export default {
  name: 'Landing',
  mounted () {
    const bg = this.$refs.bg
    if (Screen.checkIOS() && Screen.checkIsIFrame()) {
      bg.setAttribute('style', `height: ${screen.availHeight - 80}px`)
      this.showToFeatures = false
    } else {
      bg.setAttribute('style', `height: ${window.innerHeight - 60}px`)
    }
  },
  data () {
    return {
      showToFeatures: true
    }
  },
  methods: {
    toFeatures () {
      const el = this.$refs.features
      el.scrollIntoView({behavior: 'smooth', block: 'center'})
      this.$router.push({hash: '#features'})
    }
  },
  props: {
    canSkip: {
      default: false,
      type: Boolean
    }
  }
}
</script>

<style lang="scss" scoped>
.debug-info {
  z-index: 3000;
  color: white;
  position: fixed;
  top: 60px;
}

.skip {
  z-index: 1;
  float: right;
  margin-right: 10px;
  margin-top: 55px;
  .v-icon {
    z-index: 3000;
    color: white;
  }
}

.block {
  .heading {
    margin: 1em 0;
    text-align: center;
    font-weight: 300;
    color: #444;
    font-size: 30px!important;
    line-height: 40px
  }
  max-width: 1000px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 3em;
}

.bg {
  background: linear-gradient(rgba(0, 0, 0, .4), rgba(0, 0, 0, .4)), url("../assets/images/bg.jpg") 50%/cover;
  position: relative;
  width: 100%;

  .margin-lg {
    margin-top: 9em;
  }
  .margin-xs {
    margin-top: 4em;
  }
}

.slogan {
  position: absolute;
  color: white;
  width: 100%;

  h1 {
    letter-spacing: normal;
    font-weight: 400;
    font-size: 50px;
    font-family: Roboto, sans-serif;
    line-height: 75px;
    text-rendering: optimizelegibility;
    color: #fff;
  }
}

.to-features {
  position: absolute;
  bottom: 20px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  z-index: 9999;
  color: white;
}

#features {
  .feature {
    i {
      font-size: 6em;
    }
    h6 {
      font-weight: 400;
      line-height: 24px;
      font-size: 16px;
      letter-spacing: .04em;
    }
  }
}

#instruction {
  .video-container {
    margin-left: 20px;
    margin-right: 20px;
    position: relative;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>